module.exports = __webpack_public_path__ + "static/media/comprovanteError.271ec799.jpg";